<template>
  <div>
    <el-form ref="form" :model="courseForm" label-width="80px">
      <el-row>
        <el-col :span="16">
          <el-form-item label="课程名">
            <el-input disabled v-model="courseForm.lessonName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="姓名" prop="name">
            <el-input disabled v-model="courseForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in courseForm.dimensions" :key="index">
        <el-col :span="16">
          <el-form-item :label="item.name">
            <el-input :type="item.type == 1 ? 'Number' : 'text'" v-model="item.value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="16">
          <el-form-item label="体重">
            <el-input v-model="courseForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="游泳时长">
            <el-input v-model="courseForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="泳圈">
            <el-input v-model="courseForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="其他内容">
            <el-input v-model="courseForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row v-if="currentType == 'A'">
        <el-col :span="16">
          <el-form-item label="泳圈">
            <!-- <el-input v-model="courseForm.swimmingRings"></el-input> -->
            <el-select v-model="courseForm.swimmingRings" placeholder="请选择">
              <el-option v-for="item in swimInfoTable" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="courseForm.goldEnable">
        <el-col :span="16">
          <el-form-item label="金币" prop="gold">
            <el-input type="number" v-model="courseForm.gold"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="备注">
            <el-input  type="textarea" v-model="courseForm.remark" autosize=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getCourseEvalData } from "@/api/AfterClassService";
export default {
  props: {
    courseRocordId: {
      type: [Number, String],
      default: null,
    },
    defaultConfig: {
      type: Object,
      default: () => { },
    },
    commentID: {
      type: Number,
      default: 1
    },
    swimInfoTable: {
      type: Array,
      default: () => []
    },
    listtstt:{
      type:Array,
      default: () => []
    },
    currentType:{
      default: "A",
      type: String,
    }
  },
  data() {
    return {
      courseForm: {},
    };
  },
  methods: {
    getFetch() {
      getCourseEvalData({ id: this.courseRocordId }).then((response) => {
        console.log(response,'response===========')
        console.log(response.data, "response");
        this.courseForm = {
          ...response.data,
          ...this.defaultConfig,
        };
        if (this.courseForm.resolverClassEvaluation) {
          for (let i in this.courseForm.resolverClassEvaluation) {
            this.courseForm.dimensions.map((item) => {
              if (item.field == i) {
                this.$set(
                  item,
                  "value",
                  this.courseForm.resolverClassEvaluation[i]
                );
              }
            });
          }
        }
        if (this.commentID == 2) {
        this.$set(this.courseForm,'lessonName',this.listtstt[0].name)
        this.$set(this.courseForm,'name',this.listtstt[0].childName)
      }
      console.log(this.listtstt,this.courseForm, "this.listtstt");
        console.log(this.courseForm, "this.courseForm");
      });
  

    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service/course-evaluation-A/components/comment.vue